import {Component, HostBinding, Input} from '@angular/core';
import {Destroyable} from './destroyable';

@Component({
    selector: 'menu-toggle',
    template: `
        <ion-menu-toggle [ngClass]="{'reversed': reversed}">
            <ion-icon size="large" [name]="reversed ? 'chevron-back-sharp': 'chevron-forward-sharp'"></ion-icon>
        </ion-menu-toggle>
    `,
    styles: [`
        :host {
            position: absolute;
            top: 50%;
        }

        ion-menu-toggle {
            position: absolute;
            top: -80px;
            border-radius: 0 12px 12px 0;
            background: rgba(0, 0, 0, 0.8);
            box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
            color: var(--ion-color-tertiary);
            padding: 30px 8px;
        }

        ion-menu-toggle.reversed {
            border-radius: 12px 0 0 12px;
            right: 0;
            z-index: 1000;
        }
    `],
    standalone: false
})
export class MenuToggleComponent extends Destroyable {
    @HostBinding('style.right') get right() {
        return this.reversed ? '0' : null;
    }

    @Input()
    public reversed = false;
}
